import type { EmployerSiteName } from 'src/types';

const ENABLED_SITES = [] as EmployerSiteName[];

export const shouldRenderGoToMarketInSite = (siteName: EmployerSiteName) =>
  ENABLED_SITES.includes(siteName);
